import React from 'react';
import PropTypes from 'prop-types';
/* Styles */
import './legend.scss';

class Legend extends React.PureComponent {
  render() {
    return (
      <div className="glu-chart__legend">
        <ul className="glu-chart__list">{this.props.legend}</ul>
      </div>
    );
  }
}

Legend.propTypes = {
  legend: PropTypes.arrayOf(PropTypes.any).isRequired,
  legendTitle: PropTypes.string,
};

Legend.defaultProps = {
  legendTitle: '',
};

export default Legend;
